import React from 'react'
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable'
import { ENDPOINT } from '../../services/endPoints'

const Feedback = () => {
    const excludedKeys = ['id', 'updatedAt', 'deletedAt', "user_type", "user_code"];

    const compareValue = ["id", "full_name" , "phone_number", "email_id", "comments", "feedback_type","createdAt"];

    const customKeyName = {
        full_name: "Name",
        phone_number: "Phone Number",
        email_id: "Email",
        comments: "Comments",
        feedback_type: "Type",
        createdAt:"Date Time",
    };

    const customWidth = {
        full_name: "150px",
        phone_number: "150px",
        email_id: "200px",
        comments: "500px",
        feedback_type: "120px",
        createdAt:"100px"
    }

  return (
    <>
    <CustomDataTable 
                tableTitle={"Feedback List"}
                endPoint={ENDPOINT.FEEDBACK}
                filterKey={"full_name"}
                excludedKeys={excludedKeys}
                customKeyName={customKeyName}
                compareValue={compareValue}
                customWidth={customWidth}
                />
    </>
  )
}

export default Feedback